import { render, staticRenderFns } from "./BookingConfiguration.vue?vue&type=template&id=3d8b60cd&scoped=true"
import script from "./BookingConfiguration.vue?vue&type=script&lang=js"
export * from "./BookingConfiguration.vue?vue&type=script&lang=js"
import style0 from "./BookingConfiguration.vue?vue&type=style&index=0&id=3d8b60cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b60cd",
  null
  
)

export default component.exports